import AppModule, { name as appModuleName } from './app/store';
import UserModule, { name as userModuleName } from './user/store';

const modulesName = {
  appModuleName,
  userModuleName,
};

export { modulesName, AppModule, UserModule };
